// Shared URL generation utilities for sharing features

const BASE_URL = 'https://www.globalinfrastructuresherpa.com';

export const getCounterpartSeoUrl = (counterpart) => {
  const slug = (counterpart.name || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .substring(0, 60);
  const canonicalSlug = slug ? `${slug}-${counterpart.id}` : counterpart.id;
  return `${BASE_URL}/counterpart/${canonicalSlug}`;
};

export const getDealSeoUrl = (deal) => {
  return `${BASE_URL}/?deal=${deal.id}`;
};

// Social share URLs — serve OG tags to crawlers, redirect humans to SPA
export const getDealShareUrl = (deal) => {
  return `${BASE_URL}/share/deal/${deal.id}`;
};

export const getCounterpartShareUrl = (counterpart) => {
  return `${BASE_URL}/share/counterpart/${counterpart.id}`;
};

export const getSearchShareUrl = (query) =>
  `${BASE_URL}/?q=${encodeURIComponent(query)}`;

export const getMatchupShareUrl = (counterpartIds) =>
  `${BASE_URL}/?matchup=${counterpartIds.join(',')}`;
